﻿/* ===== Product Slider (no jQuery) ===== */
(() => {
  function init(root) {
    const viewport = root.querySelector('[data-viewport]');
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    const prevBtn = root.querySelector('.pslider__btn--prev');
    const nextBtn = root.querySelector('.pslider__btn--next');

    const modal = document.querySelector('[data-pslider-modal]');
    const modalImg = modal ? modal.querySelector('.pslider__modal-img') : null;
    const mClose = modal ? modal.querySelector('.m-close') : null;
    const mPrev = modal ? modal.querySelector('.m-prev') : null;
    const mNext = modal ? modal.querySelector('.m-next') : null;
    const mCount = modal ? modal.querySelector('[data-pslider-count]') : null;

    if (!viewport || slides.length === 0) return;
    let index = 0;

    function setIndex(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      syncUI();
    }

    function syncUI() {
      thumbs.forEach((t, i) => t.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
      const activeThumb = thumbs[index];
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const i = slides.indexOf(entry.target);
            if (i !== -1) {
              index = i;
              syncUI();
            }
          }
        });
      },
      { root: viewport, threshold: 0.6 }
    );
    slides.forEach((slide) => io.observe(slide));

    thumbs.forEach((t, i) => t.addEventListener('click', () => setIndex(i)));
    prevBtn?.addEventListener('click', () => setIndex(index - 1));
    nextBtn?.addEventListener('click', () => setIndex(index + 1));

    slides.forEach((s, i) => {
      const img = s.querySelector('img');
      img?.addEventListener('click', () => {
        index = i;
        if (modal) openModal();
      });
    });

    function updateModalUI() {
      if (mCount) {
        mCount.textContent = `Image ${index + 1} of ${slides.length}`;
      }
    }

    function openModal() {
      if (!modal || !modalImg) return;
      const el = slides[index].querySelector('img');
      if (!el) return;
      modalImg.classList.remove('is-loaded');
      modalImg.src = el.getAttribute('data-full') || el.currentSrc || el.src;
      if (modalImg.complete) {
        // Cached image: trigger fade in on next frame
        requestAnimationFrame(() => modalImg.classList.add('is-loaded'));
      } else {
        modalImg.onload = () => modalImg.classList.add('is-loaded');
      }
      modal.classList.add('active');
      document.documentElement.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');
      if (mClose) mClose.focus();
      updateModalUI();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('active');
      document.documentElement.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');
    }

    function modalNext() {
      if (modalImg) modalImg.classList.remove('is-loaded');
      index = (index + 1) % slides.length;
      openModal();
    }

    function modalPrev() {
      if (modalImg) modalImg.classList.remove('is-loaded');
      index = (index - 1 + slides.length) % slides.length;
      openModal();
    }

    if (mClose) mClose.addEventListener('click', closeModal);
    if (mNext) mNext.addEventListener('click', modalNext);
    if (mPrev) mPrev.addEventListener('click', modalPrev);

    if (modal) {
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('active')) return;
        if (e.key === 'Escape') closeModal();
        if (e.key === 'ArrowRight') modalNext();
        if (e.key === 'ArrowLeft') modalPrev();
      });
    }

    syncUI();
  }

  function boot() {
    document.querySelectorAll('[data-pslider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
